// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__3VwX5"};